import { useContext } from 'react';
import {
  ClientContext,
  ClientContextType,
} from '@/hooks/providers/useClientProviders';

const useClient = (): ClientContextType => useContext(ClientContext);

export default useClient;
